import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import React, { FC } from 'react';

interface IWizardBackButtonProps {
	onClick: () => void;
}

const WizardBackButton: FC<IWizardBackButtonProps> = ({ onClick }) => {
	const [loading, setLoading] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setLoading(true);
		onClick();
	}, [onClick]);

	return (
		<LoadingButton
			data-testid="wizard-back-button"
			variant="text"
			onClick={handleClick}
			startIcon={<ArrowBackIcon />}
			loading={loading}
		>
			<Typography variant="body1">
				{intl.tr('wizard.phase.back.button')}
			</Typography>
		</LoadingButton>
	);
};

export default WizardBackButton;
